import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Subtitle from './SubTitle';
import colors from '../Theme/colors';

const StyledMenuList = styled(Subtitle)`
  display: block;
  color: ${({ executive }) => (
    executive ? colors.white : colors.black)};
`;

const MenuList = ({ children, className, executive }) => (
  <StyledMenuList
    className={className}
    executive={executive}
  >
    {children}
  </StyledMenuList>
);

MenuList.defaultProps = {
  children: undefined,
  className: undefined,
  executive: undefined,
};

MenuList.propTypes = {
  /** Sets the content */
  children: PropTypes.node,
  /** Sets the classname */
  className: PropTypes.string,
  executive: PropTypes.bool,
};

export default MenuList;
